/* =========================================================================
   N4A CONNECT SET — theme.js
   Generic UI: drawers (menu + cart), overlay, body lock, esc handling.
   Cart fetch logic lives in cart.js and talks to this via events.
   ========================================================================= */
(function () {
  'use strict';

  var body = document.body;
  var overlay = document.getElementById('Overlay');
  var openDrawerEl = null;
  var lastTrigger = null;

  function restoreFocus() {
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
    lastTrigger = null;
  }

  function lockScroll(lock) {
    body.classList.toggle('overflow-hidden', lock);
  }

  function setOverlay(visible) {
    if (overlay) overlay.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function openDrawer(el) {
    if (!el) return;
    if (openDrawerEl && openDrawerEl !== el) closeDrawer(openDrawerEl, true);
    else lastTrigger = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    setOverlay(true);
    lockScroll(true);
    openDrawerEl = el;
    var focusable = el.querySelector('[autofocus], input, button, a');
    if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
  }

  function closeDrawer(el, keepOverlay) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    if (!keepOverlay) { setOverlay(false); lockScroll(false); restoreFocus(); }
    if (openDrawerEl === el) openDrawerEl = null;
  }

  function closeAll() {
    document.querySelectorAll('[data-drawer]').forEach(function (d) {
      d.setAttribute('aria-hidden', 'true');
    });
    setOverlay(false);
    lockScroll(false);
    openDrawerEl = null;
    restoreFocus();
  }

  // Open triggers
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      var target = document.getElementById(openTrigger.getAttribute('data-drawer-open'));
      openDrawer(target);
      return;
    }
    var closeTrigger = e.target.closest('[data-drawer-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeAll();
    }
  });

  if (overlay) overlay.addEventListener('click', closeAll);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // Cart.js asks us to open the cart drawer after an add-to-cart.
  // Without a drawer (setting disabled) fall back to the cart page.
  document.addEventListener('cart:open', function () {
    var cart = document.getElementById('CartDrawer');
    if (cart) { openDrawer(cart); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.assign(root + 'cart');
  });
  document.addEventListener('drawer:closeAll', closeAll);

  // Expose minimal API
  window.N4A = window.N4A || {};
  window.N4A.openDrawer = openDrawer;
  window.N4A.closeAll = closeAll;
})();

/* ---- Interactive 3D header logo (tilts toward the cursor) ---- */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  var logo = document.querySelector('.header__logo');
  if (!logo) return;
  var img = logo.querySelector('img');
  if (!img) return;

  var MAX = 20; // max degrees
  var lastE = null, raf = null;

  function apply() {
    raf = null;
    if (!lastE) return;
    var r = logo.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var dx = (lastE.clientX - cx) / Math.max(320, window.innerWidth / 2);
    var dy = (lastE.clientY - cy) / Math.max(240, window.innerHeight / 2);
    dx = Math.max(-1, Math.min(1, dx));
    dy = Math.max(-1, Math.min(1, dy));
    var ry = dx * MAX;
    var rx = -dy * MAX;
    img.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateZ(16px)';
  }

  function onMove(e) {
    lastE = e;
    logo.classList.add('is-tilting');
    if (!raf) raf = requestAnimationFrame(apply);
  }
  function reset() {
    lastE = null;
    logo.classList.remove('is-tilting');
    img.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0)';
  }

  window.addEventListener('mousemove', onMove, { passive: true });
  window.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && !e.toElement) reset();
  });
})();
